<template>
  <div class="regular-season" style="width:1200px;">
    <TeamRank :teamRankList="teamRankList" v-show="!isShowWarReport && isShowTeamRank"/>

    <Schedule :active="active" :roundList=roundList :scheduleList="scheduleList"
              v-show="!isShowWarReport && isShowSchedule"/>

    <WarReport
      v-if="isShowWarReport"
      :SelectScheduleList="SelectScheduleList"
    ></WarReport>
  </div>
</template>

<script>
const log = console.log.bind(console)
import {Loading} from 'element-ui'
import axios from 'axios'
import {Api} from '@/api/config'

import TeamRank from './TeamRank'
import Schedule from './Schedule'
import WarReport from './warReport'

export default {
  name: "RegularSeason",
  components: {
    TeamRank,
    Schedule,
    WarReport,
  },
  data: function () {
    return {
      id: 1,
      active: 0,
      isShowTeamRank: false,
      isShowSchedule: false,
      isShowWarReport: false,
      windowWidth: document.documentElement.clientWidth,
      teamRankList: [],
      // teamARankList: [],
      // teamBRankList: [],
      // teamCRankList: [],
      roundList: [],
      scheduleList: [],
      SelectScheduleList: [],
    }
  },
  created() {
    this.id = parseInt(this.$route.query.id)
    if (this.windowWidth < 750 && this.id === 1) {
      this.isShowTeamRank = true;
      this.isShowSchedule = false;
    } else if (this.windowWidth < 750 && this.id === 2) {
      this.isShowTeamRank = false;
      this.isShowSchedule = true;
    } else {
      this.isShowTeamRank = true;
      this.isShowSchedule = true;
    }
    this.getConventionalGame()
  },
  watch: {
    $route: {
      handler(to, from) {
        this.id = parseInt(to.query.id)
        if (this.windowWidth < 750 && this.id === 1) {
          this.isShowTeamRank = true;
          this.isShowSchedule = false;
        } else if (this.windowWidth < 750 && this.id === 2) {
          this.isShowTeamRank = false;
          this.isShowSchedule = true;
        } else {
          this.isShowTeamRank = true;
          this.isShowSchedule = true;
        }
      },
      deep: true
    }
  },
  methods: {
    getConventionalGame() {
      // const url = Api.conventionalGame.replace('https', 'http')
      axios.get(Api.conventionalGame).then((res) => {
        console.log(res)
        Loading.service({text: '加载中',})

        // log(res.code, res.status)
        if (res.status === 200) {
          let data = res.data.data
          this.handleData(data)

          this.active = this.roundList.findIndex(item => res.data.newStage.indexOf(item) > -1) || 0
          console.log(this.active);
        } else {
          this.$message.error('赛程请求失败1')
        }
      }).catch((error) => {
        log(error)
        this.$message.error('赛程请求失败2')
      }).finally(() => {
        this.$loading({}).close()
      })
    },

    handleData(data) {
      // 战队积分榜
      if (data.teamScore) {
        // this.teamARankList = data.teamScore[0]
        // this.teamBRankList = data.teamScore[1]
        // this.teamCRankList = data.teamScore[2]
        this.teamRankList = data.teamScore;
        console.log(this.teamRankList)
        // this.teamRankList = data.teamScore.map((team) => {
        //   // if (team.team.includes('LGD')) {
        //   //   team.team = 'LGD'
        //   // }
        //   return team
        // })
      }
      // 赛程
      let rs = data.schedule['常规赛']
      // console.info(rs)
      // let rs = data.schedule
      this.handleRegularSeasonData(rs)
    },

    // handleRegularSeasonData(data) {
    //   // key 常规赛第一轮 => 第一轮 .map((k) => k.replace('常规赛', ''))
    //   let keys = Object.keys(data)
    //   this.scheduleList = keys.map((k) => {
    //     this.roundList.push(k.replace('常规赛', ''))
    //     let scheduleList = data[k][k]
    //     return scheduleList.map((schedule) => {
    //       let o = {}
    //       // gameDate: "2022-01-14 19:00:00" => time: "19:00" date: "2022.01.14"
    //       let gd = schedule.gameDate.split(' ')
    //       o.time = gd[1].slice(0, gd[1].length - 3)
    //       // o.date = gd[0].replaceAll('-', '.')
    //       o.date = gd[0].replace(new RegExp("-","gm"),".")
    //       o.teamA_name = schedule.teamA_name
    //       o.teamB_name = schedule.teamB_name
    //       o.game_id = schedule.game_id
    //
    //       o.imgA = schedule.teamA_img
    //       o.imgB = schedule.teamB_img
    //       // 比分 score: "2:1" scoreA: 2 scoreB: 1
    //       if(schedule.score) {
    //         let s = schedule.score.split(":")
    //         if(isNaN(s[0])) {
    //           o.scoreA = "-"
    //           o.scoreB = "-"
    //         } else {
    //           o.scoreA = Number(s[0])
    //           o.scoreB = Number(s[1])
    //           o.winner = o.scoreA > o.scoreB ? 'A' : 'B'
    //         }
    //       } else {
    //         o.scoreA = "-"
    //         o.scoreB = "-"
    //       }
    //       return o
    //     })
    //   })
    // },
    handleRegularSeasonData(data) {
      // key 常规赛第一轮 => 第一轮 .map((k) => k.replace('常规赛', ''))
      let keys = Object.keys(data)
      this.scheduleList = keys.map((k) => {
        this.roundList.push(k.replace('常规赛', ''))
        let scheduleList = data[k]
        return scheduleList.map((schedule) => {
          let o = {}
          // gameDate: "2022-01-14 19:00:00" => time: "19:00" date: "2022.01.14"
          let gd = schedule.gameDate.split(' ')
          o.time = gd[1].slice(0, gd[1].length - 3)
          // o.date = gd[0].replaceAll('-', '.')
          o.date = gd[0].replace(new RegExp("-", "gm"), ".")//兼容其他浏览器
          o.teamA_name = schedule.teamA_name
          o.teamB_name = schedule.teamB_name
          o.game_id = schedule.game_id
          // if (o.teamA_name.includes('LGD')) {
          //   o.teamA_name = 'LGD'
          // }
          // if (o.teamB_name.includes('LGD')) {
          //   o.teamB_name = 'LGD'
          // }
          // 使用本地图片
          o.imgA = this.handleTeamImgName(schedule.teamA_name)
          o.imgB = this.handleTeamImgName(schedule.teamB_name)
          // 比分 score: "2:1" scoreA: 2 scoreB: 1
          if (schedule.score) {
            let s = schedule.score.split(":")
            if (isNaN(s[0])) {
              o.scoreA = "-"
              o.scoreB = "-"
            } else {
              o.scoreA = Number(s[0])
              o.scoreB = Number(s[1])
              o.winner = o.scoreA > o.scoreB ? 'A' : 'B'
            }
          } else {
            o.scoreA = "-"
            o.scoreB = "-"
          }
          return o
        })
      })
    },
    handleTeamImgName(name) {
      if (name === 'R.R.LGD') {
        return 'LGD'
      } else if (name.includes('待定')) {
        return 'TBD'
      }
      return name
    },
    routerToWarReport(gameId, index, roundIndex) {
      this.SelectScheduleList = this.scheduleList[roundIndex][index]
      this.isShowWarReport = true
      this.isShowSchedule = false
      this.isShowTeamRank = false
    },
    callBack() {
      this.isShowWarReport = false
      this.isShowSchedule = true
      this.isShowTeamRank = true
    }
  }
}
</script>

<style scoped>
.regular-season {
  display: flex;
  width: 800px;
  margin: 0px auto;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/iframe/matchSchedule/common/RegularSeason/RegularSeason.vue